import * as type from "../types";
import { SET_COLLATERAL_FILTER_DATE } from "../types";

const initialState = {
  activeList: [],
  invoiceReport: [],
  startDate: "",
  endDate: "",
  loading: false,
  error: false,
};

export default function collaterals(state = initialState, action) {
  switch (action.type) {
    case type.GET_COLLATERALS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_COLLATERALS_SUCCEEDED:
      return {
        ...state,
        activeList: action.payload,
        loading: false,
        error: false,
      };
    case type.GET_COLLATERALS_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case type.GET_INVOICE_COLLATERAL_REPORT_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_INVOICE_COLLATERAL_REPORT_SUCCEEDED:
      console.log(action.payload);
      return {
        ...state,

        invoiceReport: action.payload,
        total: {
          totalItemCount: action.payload.totalItemCount,
          totalPageCount: action.payload.totalPageCount,
        },
        loading: false,
        error: false,
      };
    case type.GET_INVOICE_COLLATERAL_REPORT_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    //------------------------
    case type.SET_COLLATERAL_FILTER_DATE:
      if (action.payload.startDate) {
        return {
          ...state,
          startDate: action.payload.startDate,
        };
      }
      //------------------------
      if (action.payload.endDate) {
        return {
          ...state,
          endDate: action.payload.endDate,
        };
      }
      return {
        ...state,
      };
    default:
      return state;
  }
}
